import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MARKETPLACE_URL } from 'src/app/app.constants';
import { ContentState } from 'src/app/store/state/content.state';
import { setTitleComponent } from 'src/app/utils/titles.util';

@Component({
    selector: 'u4-cpp-marketplace',
    templateUrl: './marketplace.component.html',
    styleUrls: ['./marketplace.component.scss'],
})
export class MarketplaceComponent implements OnDestroy, OnInit {

    public labels: {[key: string]: string};
    public redirectMarketplaceUrl = MARKETPLACE_URL;
    public email: string;
    public descriptionOne: string;
    public descriptionTwo: string;
    public title$ = new Observable<any>();
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<ContentState>,
        private titleService: Title
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => { 
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['marketplace.title']));
            this.descriptionOne = this.labels['marketplace.description.one'];
            this.descriptionTwo = this.labels['marketplace.description.two'];
        });
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
